import { PaymentDeliveryMethodType } from '@routable/shared';
import React from 'react';
import { GetPaidViaPayPal } from '../../../GetPaidViaPayPal';
import { AddBankAccountManually, AddCheckAddress, ConnectBankAccountViaPlaid } from './components';
export const AddFundingAccountOptions = ({ deliveryMethodsAccepted }) => {
    const acceptACH = deliveryMethodsAccepted.some((route) => route === PaymentDeliveryMethodType.ACH);
    const acceptCheck = deliveryMethodsAccepted.some((route) => route === PaymentDeliveryMethodType.CHECK);
    const acceptPaypal = deliveryMethodsAccepted.some((route) => route === PaymentDeliveryMethodType.PAYPAL);
    return (React.createElement("div", { className: "flex flex-col gap-3" },
        acceptACH && (React.createElement(React.Fragment, null,
            React.createElement(ConnectBankAccountViaPlaid, null),
            React.createElement(AddBankAccountManually, null))),
        acceptCheck && React.createElement(AddCheckAddress, null),
        acceptPaypal && React.createElement(GetPaidViaPayPal, null)));
};
